export const BACKEND_URL = 'https://media.scoreplay.io'
export const BACKEND_API_URL = BACKEND_URL + '/api'
export const FAN_URL = 'https://api.scoreplay.fan'
export const FAN_API_URL = FAN_URL + '/api'
export const ANALYTICS_URL = 'https://analytics.scoreplay.io'
